import { constantRoutes } from '@/router'

const permission = {
  state: {
    role: 0, // 1是fm 2 是其他
    routes: constantRoutes
  },
  mutations: {
    SET_ROLE: (state, val) => {
      state.role = val
    }
  },
  actions: {
    SetRole({ commit }, role) {
      return new Promise(resolve => {
        commit('SET_ROLE', role)
        resolve()
      })
    },
    GetRole({ state }) {
      return new Promise(resolve => {
        resolve(state.role)
      })
    }
  }
}

export default permission
